const File = [
  { type: 'item', text: 'Close' },
];

const View = [
  { type: 'item', disable: true, text: 'Sort by Skill Level' },
  { type: 'item', disable: true, text: 'Sort by Usefulness' },
];

const Help = [
  { type: 'item', disable: true, text: 'About stack_overflow.exe' },
];

export default { File, View, Help };
